import React from "react";
import { SectionCard } from "./RdMarketingGroup";
import { Box, Grid, TextField, Typography } from "@mui/material";
import FilterBuilder from "./FilterBuilder";

const IndexSelector = ({
  campaignPost,
  setCampaignPost,
  contacts,
  selectedGroup,
  contactGroup,
}) => {
  const handleStartIndexChange = (event) => {
    const value = event.target.value;
    const parsedValue = parseInt(value, 10);
    setCampaignPost((prev) => ({
      ...prev,
      startIndex: isNaN(parsedValue) ? 1 : parsedValue < 1 ? 1 : parsedValue,
    }));
  };

  const handleEndIndexChange = (event) => {
    const value = event.target.value;
    const parsedValue = parseInt(value, 10);
    setCampaignPost((prev) => ({
      ...prev,
      endIndex: isNaN(parsedValue)
        ? contacts.length
        : parsedValue < 1
        ? 1
        : parsedValue,
    }));
  };
  return (
    <SectionCard
      title="Contact Range"
      helpText="Select a subset of contacts to include in this campaign"
    >
      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle2" gutterBottom fontWeight="500">
          Total contacts: {contacts.length}
        </Typography>
      </Box>

      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={5}>
          <TextField
            fullWidth
            size="small"
            type="number"
            label="Start Position"
            value={campaignPost.startIndex}
            onChange={handleStartIndexChange}
            inputProps={{
              min: 0,
              max: campaignPost.endIndex || contacts.length,
            }}
            helperText="Start position starts from 1"
          />
        </Grid>
        <Grid item xs={12} sm={2} sx={{ textAlign: "center" }}>
          <Typography variant="body2">to</Typography>
        </Grid>
        <Grid item xs={12} sm={5}>
          <TextField
            fullWidth
            size="small"
            type="number"
            label="End Position"
            value={campaignPost.endIndex || contacts.length}
            onChange={handleEndIndexChange}
            inputProps={{
              min: campaignPost.startIndex || 1,
              max: contacts.length,
            }}
            helperText={`End position should not be more than ${contacts.length}`}
          />
        </Grid>
      </Grid>
      {contactGroup === 2 && (
        <Box mt={2}>
          <FilterBuilder
            campaignPost={campaignPost}
            setCampaignPost={setCampaignPost}
            selectedGroup={selectedGroup}
          />
        </Box>
      )}
    </SectionCard>
  );
};

export default IndexSelector;
